<template>
  <button type="button" :class="btnClass" @click="showProviderModal">
    <FileEarmarkPlusIcon />
    {{ i18n('Add New') }}
  </button>

  <ProviderModal ref="ProviderModal" @created="$emit('created', $event)" />
</template>
<script>
import ProviderModal from "@/components/provider/ProviderModal.vue";
import FileEarmarkPlusIcon from "@/assets/svg/file-earmark-plus.vue";

export default {
  components: {
    ProviderModal,
    FileEarmarkPlusIcon,
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-outline-light',
    },
  },
  data() {
    return {
      formData: {},
    };
  },
  emits: [
    'added',
    'created'
  ],
  methods: {
    showProviderModal() {
      this.$refs['ProviderModal'].show();
    },
  }
};
</script>